import { useState, useEffect } from 'react';

const useClickOutside = ({ onClickOutside, events = ["click", "touchend"] }) => {
  const [node, setNode] = useState(null);
  useEffect(() => {
    const onClick = (event) => {
      if (node && !node.contains(event.target)) {
        onClickOutside(event);
      }
    };
    const body = document && document.body;
    if (body) {
      for (const event of events) {
        body.addEventListener(event, onClick, { capture: true });
      }
      return () => {
        for (const event of events) {
          body.removeEventListener(event, onClick, { capture: true });
        }
      };
    }
    return () => {
    };
  }, [node, onClickOutside, events]);
  return [setNode];
};

export { useClickOutside };
//# sourceMappingURL=useClickOutside.es.js.map
